// spjs の characteristic 値は base64 文字列。BLE バイト列 <-> base64 の変換のみを担う
// トランスポート層ヘルパ（AES 暗号や CRC とは無関係）。旧 src/utils/packet.ts から移設。

export function encodePacket(packet: Uint8Array): string {
  const binaryString = String.fromCharCode.apply(
    null,
    packet as unknown as number[]
  )
  return window.btoa(binaryString)
}

export function decodePacket(packetString: string): Uint8Array {
  const binaryString = window.atob(packetString)
  const packetArray = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    packetArray[i] = binaryString.charCodeAt(i)
  }
  return packetArray
}
